export const parseSizeToBytes = (value) => {
  if (!value) return 0;

  const parts = value.trim().split(' ');
  if (parts.length < 2) return 0;

  const size = parseFloat(parts[0]);
  const unit = parts[1].toUpperCase();

  if (isNaN(size)) return 0;

  switch (unit) {
    case 'BYTES':
    case 'BYTE': return size;
    case 'KB': return size * 1024;
    case 'MB': return size * 1024 * 1024;
    case 'GB': return size * 1024 * 1024 * 1024;
    case 'TB': return size * 1024 * 1024 * 1024 * 1024;
    default: return size; // fallback
  }
};
